"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MobileButtons_1 = require("components/MobileButtons");
var WorksiteStatusMobileButtons = function (_a) {
    var handleOnClickStatus = _a.handleOnClickStatus, props = _a.props;
    var onClickHandler = function (status) {
        handleOnClickStatus(props.selectedJobIndex, status, props.setJobsList, props.updateJob, props.jobs);
        props.setSelectedJobIndex(undefined);
        props.setMobileButtons(false);
    };
    var startedSettings = [
        {
            icon: 'fa fa-angle-double-right',
            localization: 'diaryEntryView/worksiteStatus/mobile/startJob',
            onClick: function () { return onClickHandler('IN_PROGRESS'); }
        },
        {
            icon: 'fas fa-times-circle',
            localization: 'diaryEntryView/worksiteStatus/mobile/deleteJob',
            onClick: function () {
                if (props.jobs) {
                    props.setJobsList(props.deleteJob(props.selectedJobIndex, props.jobs));
                    props.setSelectedJobIndex(undefined);
                    props.setMobileButtons(false);
                }
            }
        }
    ];
    var inProgressSettings = [
        {
            icon: 'fa fa-check-circle',
            localization: 'diaryEntryView/worksiteStatus/mobile/doneJob',
            onClick: function () { return onClickHandler('DONE'); }
        },
        {
            icon: 'fa fa-play-circle',
            localization: 'diaryEntryView/worksiteStatus/mobile/startedJob',
            onClick: function () { return onClickHandler('STARTED'); }
        },
        {
            icon: 'fas fa-pause-circle',
            localization: 'diaryEntryView/worksiteStatus/mobile/pauseJob',
            onClick: function () { return onClickHandler('ON_HOLD'); }
        }
    ];
    var doneSettings = [
        {
            icon: 'fa fa-angle-double-right',
            localization: 'diaryEntryView/worksiteStatus/mobile/startJob',
            onClick: function () { return onClickHandler('IN_PROGRESS'); }
        }
    ];
    var onHoldSettings = [
        {
            icon: 'fa fa-angle-double-right',
            localization: 'diaryEntryView/worksiteStatus/mobile/startJob',
            onClick: function () { return onClickHandler('IN_PROGRESS'); }
        }
    ];
    var defaultSettings = onHoldSettings;
    var settingsByStatus = {
        STARTED: startedSettings,
        IN_PROGRESS: inProgressSettings,
        DONE: doneSettings,
        ON_HOLD: onHoldSettings
    };
    var settings = settingsByStatus[props.selectedJobStatus] || defaultSettings;
    return (React.createElement(MobileButtons_1.default, { className: "joblist-mobile-buttons", settings: settings }));
};
exports.default = WorksiteStatusMobileButtons;
